module.exports = __webpack_public_path__ + "static/media/star.b6d494d7.svg";